export default __webpack_public_path__ + "static/media/Close.ad800662.svg";